var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuadroPrincipal',{attrs:{"borderTop":"","titulo":_vm.titulo,"classe":_vm.classe}},[_c('ImpostoSemResultado',{attrs:{"titulo":_vm.titulo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }